<template>
  <div>
    <!-- 标题 -->
    <!-- <div>
      <van-nav-bar
        title="社区资讯"
      />
    </div> -->
    <!-- tab栏 -->
    <van-sticky>
      <!-- <van-tabs @click="onClickOnlyOne" v-if="TitleList.length == '1'" color="#f63e3b" title-active-color="#f63e3b">
        <van-tab name="全部" title="全部"> </van-tab>
        <van-tab v-for="item in TitleList[0].Children" :key="item.TKId" :name="item.TKId" :title="item.Name"> </van-tab>
      </van-tabs>
      <van-tabs @click="topClick" v-else color="#f28c76" title-active-color="#f28c76">
        <van-tab v-for="item in TitleList" :key="item.TKId" :name="item.TKId" :title="item.Name">
          <van-tabs
            v-if="item.Children.length != '0'"
            v-model="activeName"
            @click="onClick"
            color="#f28c76"
            title-active-color="#f28c76"
          >
            <van-tab v-for="item in item.Children" :key="item.TKId" :name="item.TKId" :title="item.Name"> </van-tab>
          </van-tabs>
        </van-tab>
      </van-tabs> -->
      <van-tabs
        @click="onClickOnlyOne"
        color="#f63e3b"
        title-active-color="#f63e3b"
      >
        <van-tab name="全部" title="全部"> </van-tab>
        <van-tab
          v-for="item in TitleList"
          :key="item.TKId"
          :name="item.TKId"
          :title="item.Name"
        >
        </van-tab>
      </van-tabs>
    </van-sticky>

    <div class="information">
      <!-- 全部 -->
      <div class="center borderClass" v-for="item in list" :key="item.index">
        <div @click="gotoUrl('/notice/detail/' + item.RIId)">
          <div class="Content">
            <div
              style="display: inline-block; width: 33%"
              class="ContentA"
              ref="getHeight"
            >
              <img
                v-if="item.Thematic"
                style="border-radius: 5px; min-height: 90px"
                :src="item.Thematic"
                alt=""
              />
              <img
                v-else
                style="border-radius: 5px; min-height: 90px"
                src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cdb4.png"
                alt=""
              />
            </div>
            <div style="display: inline-block; width: 63%" class="ContentB">
              <div class="centerTitle van-multi-ellipsis--l2">
                {{ item.Title }}
              </div>
              <span
                class="centertime van-multi-ellipsis--l2"
                style="margin: 5px 0px; font-size: 13px; color: #666666"
                >{{ item.Summary }}</span
              >
            </div>
            <span
              class="centertime"
              style="float: right; margin-top: -10px; color: black"
              >{{ item.IssTime | timeFilter }}</span
            >
          </div>
        </div>
      </div>
      <!-- 没有更多数据了 -->
      <div v-if="hidden" class="hidden">── 没有更多数据了 ──</div>
    </div>
  </div>
</template>
<script>
import { setOpenId, getOpenId } from "@/utils/auth";
import { WeTrealinfoPage, WeTinfokindPage } from "@/api/RealInfo";
export default {
  data() {
    return {
      tkId: 0, //tab栏
      activeName: "",
      list: {}, //资讯列表
      listfrom: {
        pageNum: 1,
        pageSize: 10,
        PAKind: 99,
      }, //查询传参
      hidden: true, //没有更多数据了
      TitleList: [],
    };
  },
  filters: {
    timeFilter(value) {
      if (value != undefined) {
        let gstime = value.replace("T", " ");
        return gstime;
      }
    },
  },
  methods: {
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },
    // 资讯分类
    getPBActivityList: function () {
      WeTinfokindPage({ PAKind: 99, pageSize: 99 }).then((res) => {
        this.TitleList = res.data.data;

        // if (this.TitleList[0].Children != '0') {
        //   this.listfrom.TKId = 0
        //   // this.listfrom.TKId = this.TitleList[0].Children[0].TKId
        // } else {
        //   this.listfrom.TKId = this.TitleList[0].TKId
        //   // this.listfrom.TKId = this.TitleList[0].TKId
        // }
        this.getList();
      });
    },
    // 获取分页列表
    getList() {
      WeTrealinfoPage(this.listfrom)
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.count == 0) {
              this.list = {};
            } else {
              this.list = res.data.data;
              // for (var i = 0; i < this.list.length; i++) {
              //   if (this.list[i].Thematic == '') {
              //     this.list[i].Thematic = 'http://cuiyunapi.dexian.ren//upload/images/2021/7/873b94ff-81d.png'
              //   }
              // }
            }
          }
        })
        .catch(() => {});
    },
    topClick: function (name, title) {
      for (let index = 0; index < this.TitleList.length; index++) {
        const element = this.TitleList[index];
        if (element.Children.length != "0") {
          if (element.TKId == name) {
            this.listfrom.TKId = element.Children[0].TKId;
            this.activeName = element.Children[0].TKId;
            this.getList();
          } else {
            this.listfrom.TKId = element.TKId;
            this.getList();
          }
        }
      }
    },
    // tab点击切换事件
    onClick(name, title) {
      this.list = [];
      this.listfrom.TKId = name;
      this.listfrom.pageNum = 1;
      this.getList();
    },
    onClickOnlyOne(name, title) {
      console.log(name);
      if (name == "全部") {
        var names = undefined;
      } else {
        var names = name;
      }
      this.list = [];
      this.listfrom.TKId = names;
      this.listfrom.pageNum = 1;
      this.getList();
    },
  },
  mounted() {
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }

    this.getPBActivityList();
  },
};
</script>
<style scoped>
.hidden {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin: 10px 0px 25px 0px;
}
.information {
  width: 95%;
  margin: auto;
}
.borderClass {
  padding: 0;
  box-shadow: 0px 5px 17px 1px rgb(0 0 0 / 7%);
}
.borderClass .Content {
  padding: 8px;
  margin-top: 10px;
}
</style>
